<div class="modal-container">
    <div class="modal-header">
      <h1 mat-dialog-title>Galería de Fotos</h1>
      <button mat-icon-button (click)="onClose()" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div mat-dialog-content class="modal-content">
      <app-ofertas-gallery [imagenes]="imgs" [id_usuario]="usuario._id"></app-ofertas-gallery>
    </div>
  </div>
  